import { createThunk, ListModel, model } from 'mst-collection';
import { castToSnapshot, types } from 'mobx-state-tree';

import { ConversationModel } from './ConversationModel';
import { Api, schemas } from '@api';
import { handleFlow, shouldRejectPagination } from '../utils';

export class ConversationList extends ListModel(
  types.reference(ConversationModel),
  {
    idAttribute: 'id',
    schema: schemas.ConversationListSchema,
    pageSize: 20,
  },
) {
  fetch = createThunk(() => {
    return async function fetch(this: ConversationList) {
      const res = await Api.Messaging.getConversations({
        count: this.pageSize,
        start: 0,
      });

      this.set(res.data.conversations);
    };
  });

  /**
   * Extra ThunkModel for UI purposes
   * We are using this thunk to have ability to refresh conversations in background
   * without UI pull to refresh effect
   * TODO: find another approach
   */
  refresh = createThunk(() => {
    return async function refresh(this: ConversationList) {
      await this.fetch.run();
    };
  });

  fetchMore = createThunk(() => {
    return async function fetchMore(this: ConversationList, flow) {
      if (shouldRejectPagination(this)) {
        return;
      }

      await handleFlow(flow, async () => {
        const res = await Api.Messaging.getConversations({
          count: this.pageSize,
          start: this.offset,
        });
        this.append(castToSnapshot(res.data.conversations));
      });
    };
  }, false);
}

export const ConversationListModel = model(ConversationList);
